import { useNavigate } from "react-router-dom";
import { Icon } from "src/components";

interface Props {
  title: string;
  path?: any;
}

const BackButton = ({ title, path }: Props) => {
  const navigate = useNavigate();
  const checkPath = path !== undefined ? path : -1;

  return (
    <span className="inline-block" onClick={() => navigate(checkPath)}>
      <span className="flex cursor-pointer ">
        <Icon name="chevron" className="inline-block" />
        <span className="ml-6">{title}</span>
      </span>
    </span>
  );
};

export default BackButton;
